import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import { AddrComponent } from '../addr/addr.component';

@Component({
  selector: 'app-reg',
  templateUrl: './reg.component.html',
  styleUrls: ['./reg.component.css']
})
export class RegComponent implements OnInit {

	pageObj:any = "curr";

	frm : FormGroup;

	logi_user:any;
	data:any = [];
	getData:any = [];

	idx:any;

	/* 페이징 */
	cp:any = 1;

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	btn_txt:any = "등록";

	constructor(
		private http: HttpClient,
		private router: Router,
		public dialog: MatDialog,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			company: new FormControl(''),
			depart: new FormControl(''),
			name: new FormControl('', Validators.required),
			tel: new FormControl('', Validators.required),
			addr1: new FormControl('', Validators.required),
			addr2: new FormControl(''),
			sido: new FormControl('', Validators.required),
			gugun: new FormControl('', Validators.required),
			dong: new FormControl('', Validators.required),
			xpoint: new FormControl('', Validators.required),
			ypoint: new FormControl('', Validators.required),
			road: new FormControl(''),
			memo: new FormControl('')
		});
	}

	ngOnInit() {
		this.idx = this.func.getParameterByName("idx", window.location.href);
		if( this.idx == null ){ this.idx = ""; }else{ this.btn_txt = "수정"; }

		this.cp = this.func.getParameterByName("page", window.location.href);
		if( this.cp == null ){ this.cp = ""; }

		this.skey = this.func.getParameterByName("skey", window.location.href);
		if( this.skey == null ){ this.skey = ""; }

		this.sw = this.func.getParameterByName("sw", window.location.href);
		if( this.sw == null ){ this.sw = ""; }

		this.getPartnerData(this.idx);
	}

	async getPartnerData(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", this.idx);

		this.http.post(this.env.API_URL + 'api/partner.data.php', formData).subscribe((response) => {
			this.frm.get('company').setValue( response['data']['com'] );
			this.frm.get('depart').setValue( response['data']['depart'] );
			this.frm.get('name').setValue( response['data']['name'] );
			this.frm.get('tel').setValue( response['data']['tel'] );
			this.frm.get('addr1').setValue( response['data']['addr1'] );
			this.frm.get('addr2').setValue( response['data']['addr2'] );
			this.frm.get('memo').setValue( response['data']['memo'] );
			this.frm.get('sido').setValue( response['data']['sido'] );
			this.frm.get('gugun').setValue( response['data']['gugun'] );
			this.frm.get('dong').setValue( response['data']['dong'] );
			this.frm.get('xpoint').setValue( response['data']['xpoint'] );
			this.frm.get('ypoint').setValue( response['data']['ypoint'] );
			this.frm.get('road').setValue( response['data']['road'] );
		});
	}

	async regForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("idx", this.idx);
		formData.append("company", this.frm.get('company').value);
		formData.append("depart", this.frm.get('depart').value);
		formData.append("name", this.frm.get('name').value);
		formData.append("tel", this.frm.get('tel').value);
		formData.append("addr1", this.frm.get('addr1').value);
		formData.append("addr2", this.frm.get('addr2').value);
		formData.append("sido", this.frm.get('sido').value);
		formData.append("gugun", this.frm.get('gugun').value);
		formData.append("dong", this.frm.get('dong').value);
		formData.append("xpoint", this.frm.get('xpoint').value);
		formData.append("ypoint", this.frm.get('ypoint').value);
		formData.append("road", this.frm.get('road').value);
		formData.append("memo", this.frm.get('memo').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/partner.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
			this.router.navigate(['/partner']);
		});
	}

	openAddr() {
		const modal = this.dialog.open(AddrComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '540px',
			data: {
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['addr'] )
				{
					this.frm.get('addr1').setValue(dataReturned['data']['addr']);
					this.frm.get('sido').setValue( dataReturned['data']['sido'] );
					this.frm.get('gugun').setValue( dataReturned['data']['gugun'] );
					this.frm.get('dong').setValue( dataReturned['data']['dong'] );
					this.frm.get('xpoint').setValue( dataReturned['data']['x'] );
					this.frm.get('ypoint').setValue( dataReturned['data']['y'] );
					this.frm.get('road').setValue( dataReturned['data']['road'] );
				}
			}
		});
	}
}
